module.exports = __webpack_public_path__ + "9f31aaf98029c9f4afc5cbc6c45e614c.svg";